import { render } from "./CourseListView.vue?vue&type=template&id=4670dd67&scoped=true&ts=true"
import script from "./CourseListView.vue?vue&type=script&lang=ts"
export * from "./CourseListView.vue?vue&type=script&lang=ts"

import "./CourseListView.vue?vue&type=style&index=0&id=4670dd67&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4670dd67"]])

export default __exports__